import React from 'react';
import { useTranslation } from "react-i18next";
import { Modal, Form, Input, Select } from "antd";
import { identity } from "../../utils/getIdentity";
import '../SignPasswordModal/style.scss';
import '../../layout/Modal.scss';
import '../ResendEmail2FA/style.scss';
import './style.scss';
import Button from "../Button";

const DeleteAddress = ({ visible, close, handleDeleteAddress }) => {
  const { t } = useTranslation();
  return (
    <Modal
      title={t('addressBook.delete_title')}
      visible={visible}
      width={385}
      onCancel={close}
      footer={null}
      className={`modal modal-${identity}`}
    >
      <div className="sign-password address-modal">
        <div className="address-modal__title">{t("addressBook.delete_address")}</div>

        <div className="modal-buttons">
          <Button onClick={handleDeleteAddress} type="primary">{t("addressBook.delete")}</Button>
          <Button onClick={close} type="secondary">{t('addressBook.cancel')}</Button>
        </div>
      </div>
    </Modal>
  )
};

export default DeleteAddress;